Catalog = Backbone.View.extend {

	CATEGORIES: ['therapy_unit', 'canister', 'bandage', 'wound_filler']

	COMPANIES: ['smith_nephew',
		'hartmann',
		'l_r',
		'medica',
		'primed',
		'apexmed',
		'convatec'
	]

	events:
		'click .item-trigger': 'processFilter'
		'click .toggle-list': 'toggleFilter'
		'click .sliding-bar .scroll-top-button': 'scrollTop'
		'click .sliding-bar .more-link[data-reveal]': 'revealMore'
		'click .modal__close-button': 'closeModal'

	filter:
		type: undefined
		facet: undefined

	filter_default: [
		'therapy_unit'
		'smith_nephew'
	]

	initialize: () ->
		@catalogContainer = $ '.catalog-item-content'
		@filterLinks = $ '.catalog-filter a.item-trigger'
		@sections = $ '.catalog-filter__section'

		@filterToggle = $ 'ul.toggle-list'
		@filterItems = @filterToggle.find '.item-toggle-link'
		@dropdownToggle = $ '.toggle-dropdown-list'
		@dropdownItems = @dropdownToggle.find '.dropdown'
		@sidebarArea = $ '.sliding-bar__text'

		# templates
		@listTempl = Handlebars.compile window.catalog_template
		@sidebarTempl = Handlebars.compile window.catalog_desc_template

		#sliding bar
		@slidingBarWr = $ '.sliding-bar-wrapper'
		@slidingBarWrH = @slidingBarWr.height()
		@slidingBarWrPos = @slidingBarWr.offset().top
		@slidingBar = $ '.sliding-bar'
		@slidingBarPos = @slidingBarWr.offset().top
		@slidingBarWidth = @slidingBar.width()
		@slidingBarHeight = @slidingBar.height()


		Handlebars.registerHelper 'adjust_items', (num) ->
			if num > 2
				return 'more-items'
			else
				return ''

		do @render

	render: () ->
		_.bind @processFilter, @
		_.bind @toggleFilter, @
		_.bind @revealMore, @

		if _qs[1] and _qs[1] in @CATEGORIES
			@filter.type = 'category'
			@filter.facet = _qs[1]
		else if _qs[1] and _qs[1] in @COMPANIES
			@filter.type = 'company'
			@filter.facet = _qs[1]
		else
			@filter.type = 'category'
			@filter.type = 'therapy_unit'

		$(window).scroll _.bind @catalogScroll, @

		do @_switchFilter
		return null

	showCategory: () ->
		select_type = @filter.type
		value = @filter.facet
		group_type = if select_type == 'company' then 'category' else 'company'
		filter = {}
		filter[select_type] = value
		items = _.where window.catalog_source, filter
		grouped = _.groupBy items, group_type
		groups = @_prepareContext grouped, group_type
		list = @listTempl {
			sectionHeader: window.catalog_categories[value][0]
			sectionHeaderRus: window.catalog_categories[value][1]
			items: groups
		}
		console.log {
			sectionHeader: window.catalog_categories[value][0]
			sectionHeaderRus: window.catalog_categories[value][1]
			items: groups
		}
		@catalogContainer.html list
		@slidingBarWr.height(@catalogContainer.height() + 'px')
		@slidingBarWrH = @slidingBarWr.height()
		console.log 'height', @slidingBarWrH

	# showManufacturer: (name) ->
	# 	items = _.where window.catalog_source, {company: name}
	# 	grouped = _.groupBy items, 'category'
	# 	groups = @_prepareContext grouped, 'category'
	# 	console.log groups
	# 	list = @listTempl {
	# 		sectionHeader: window.catalog_manufacturers[name][0]
	# 		sectionHeaderRus: window.catalog_manufacturers[name][1]
	# 		items: groups
	# 	}
	# 	console.log {
	# 		sectionHeader: window.catalog_manufacturers[name][0]
	# 		sectionHeaderRus: window.catalog_manufacturers[name][1]
	# 		items: groups
	# 	}
	# 	@catalogContainer.html list

	_prepareContext: (grouped, headerField) ->
		result = _.map grouped, (group) ->
			return null if group.length == 0
			code = group[0][headerField]
			console.log code
			return {
				header: window.catalog_categories[code][0]
				header_rus: window.catalog_categories[code][1]
				elements: group
			}
		return result

	processFilter: (ev) ->
		elem = $ ev.target
		@filter.type = elem.attr 'data-type'
		@filter.facet = elem.attr 'data-facet'
		pos = if @filter.type == 'category' then 0 else 1
		@filter_default[pos] = @filter.facet


		do @_switchFilter

		do ev.preventDefault

	toggleFilter: (ev) ->
		_pos = parseInt @filterToggle.attr('data-pos')
		pos = (_pos + 1) % 2
		@filter.type = if pos == 0 then 'category' else 'company'
		@filter.facet = @filter_default[pos]

		# @_renderFilter pos
		# do @_renderDropdown
		# @showCategory @filter.type, @filter.facet, group_type

		do @_switchFilter

		ev.preventDefault()

	catalogScroll: (ev) ->
		margin = 30
		pos = $(window).scrollTop()
		@slidingBar.css('width', @slidingBarWidth + 'px')

		console.log pos, (@slidingBarPos - margin), (@slidingBarWrPos + @slidingBarWrH - @slidingBarHeight)

		if (pos > (@slidingBarPos - margin)) and (pos < (@slidingBarWrPos + @slidingBarWrH - @slidingBarHeight))
			@slidingBar.attr 'data-state', 'sliding'
		else if pos < (@slidingBarPos - margin)
			@slidingBar.attr 'data-state', 'top'
		else
			@slidingBar.attr 'data-state', 'bottom'

	revealMore: (ev) ->
		ev.preventDefault()
		elem = $ ev.target
		facet = elem.attr 'data-reveal'

		modal = $ '#more-modal__'+facet
		console.log modal, elem, facet
		return if modal.length == 0

		do modal.modal

	_switchFilter: () ->
		pos = if @filter.type == 'category' then 0 else 1

		history && history.replaceState && history.replaceState null, null, '/catalog/'+@filter.facet

		do @showCategory
		do @_renderSidebar

		@_renderFilter pos

	_renderSidebar: () ->
		obj = window.catalog_cat_descs[@filter.facet]
		if not obj
			@sidebarArea.html ''
			return

		result = @sidebarTempl {
			hideHeader: !!(@filter.type == 'company')
			header: window.catalog_categories[@filter.facet]
			text: obj.text
			facet: @filter.facet
			link: obj.link
		}

		@sidebarArea.html result


	_renderFilter: (pos) ->
		@filterToggle.attr 'data-pos', pos
		@dropdownToggle.attr 'data-pos', pos

		@filterItems.removeClass 'selected'
		@dropdownItems.removeClass 'selected'

		$(@filterItems[pos]).addClass 'selected'
		$(@dropdownItems[pos]).addClass 'selected'

		do @_renderDropdown

	_renderDropdown: () ->
		elem = $ '.item-trigger[data-facet="'+@filter.facet+'"]'

		elem.addClass 'selected'
		elem.parents('.dropdown-menu').siblings('.dropdown-current').children('.label').text elem.text()

	scrollTop: (ev) ->
		$('body,html').animate({scrollTop: 0}, 300, 'swing')
		ev.preventDefault()

	closeModal: (ev) ->


}

window.catalog_template = """

	<!-- <h1 class="main-header">{{sectionHeader}}</h1> -->
	<div class="unit-list-wrapper">
		{{#each items}}
			<div class="list-header">
				<div class="list-header__caption">
					{{{header}}}
				</div>
				{{#if header_rus}}
				<div class="list-header__caption_rus">
					{{{header_rus}}}
				</div>
				{{/if}}
			</div>
			{{#each elements}}
				<div class="unit-list-description {{#if img_src}}unit-list-description_rich{{/if}} clearfix">
					{{#if img_src}}
					<div class="unit-img">
						<img src="{{img_src}}" alt="{{img_alt}}" class="unit-img__container">
					</div>
					{{/if}}
					<div class="unit-description">
						<h3 class="unit-name">
							{{#if link}}<a href="{{link}}" class="item-link">{{/if}}
							{{{name}}}
							{{#if link}}</a>{{/if}}
						</h3>
						{{#if items}}
						<div class="vendor-wrapper {{adjust_items items.length}}">
							{{#each items}}
								<div class="vendor-code">
									{{#if features}}
										<span class="slug feature">{{features}}</span>
									{{/if}}
									{{#if amount}}
										<span class="slug amount {{#unless features}}feature{{/unless}}">Кол-во:&nbsp;{{amount}}</span>
									{{/if}}
									{{#if code}}
										<span class="slug code">Артикул:&nbsp;{{code}}</span>
									{{/if}}
								</div>
							{{/each}}
						</div>
						{{/if}}
					</div>
				</div>
			{{/each}}

		{{/each}}
	</div>

"""

window.catalog_desc_template = """
	{{#unless hideHeader}}
		<h4 class="sliding-bar__content__header">
			{{header.[0]}}
		</h4>
		{{#if header.[1]}}
			<span class="sliding-bar__content__subhead">{{header.[1]}}
		{{/if}}
	{{/unless}}
	<p class="sliding-bar__content__description">
		{{{text}}}
	</p>
	<div class="more-link-wrapper">
		{{#if link}}
			<a href="{{ link.href }}" class="more-link" target="_blank" >{{link.caption}}</a>
		{{else}}
			<a href="#" class="more-link" data-reveal="{{facet}}" >Подробнее</a>
		{{/if}}

	</div>
	<!-- <ul class="sliding-bar__links">
		<li class="item">
			<a href="#" class="item-link">PAUL HARTMANN</a>
		</li>
		<li class="item">
			<a href="#" class="item-link">Lohmann &amp; Rauscher GmbH</a>
		</li>
		<li class="item">
			<a href="#" class="item-link">PRIMED</a>
		</li>
	</ul> -->
"""

`

window.catalog_categories = {
	'therapy_unit': ['Аппараты для вакуумной терапии'],
	'canister': ['Канистры'],
	'bandage': ['Герметизация повязки'],
	'wound_filler': ['Наполнители ран'],
	'convatec': ['ConvaTec', 'Конватек'],
	'smith_nephew': ['Smith & Nephew GmbH', 'Смит энд Нефью ГмбХ'],
	'hartmann': ['PAUL HARTMANN', 'Пауль Хартманн'],
	'l_r': ['Lohmann & Rauscher GmbH', 'Ломан & Раушер'],
	'medica': ['НПП «МЕДИКА»', ''],
	'primed': ['PRIMED', 'ПриМед'],
	'apexmed': ['Apexmed', 'Апексмед']
}`

window.catalog_cat_descs =
	'therapy_unit': null
	'canister':
		text: 'Канистры для сбора экссудата это одноразовые накопительные емкости (мешки) для сбора отделяемого из&nbsp;раны, которые подлежат обеззараживанию и&nbsp;утилизации после заполнения.'
	'bandage':
		text: 'Для лечения ран методом вакуум-терапии необходимо хорошо зафиксировать раневую повязку на&nbsp;поверхности кожи. Для фиксации повязки и&nbsp;создания вакуума в&nbsp;ране используют прозрачную тонкую пленку.'
	'wound_filler':
		text: 'При лечении сложных ран методом вакуум-терапии в&nbsp;качестве наполнителя для раны применяют губки из&nbsp;медицинского полиуретана или хлопчатобумажную марлю особого плетения. На&nbsp;дно раны укладывают атравматическое раневое покрытие.'
	'convatec':
		text: '<div class="logo-wrapper"><img alt="ConvaTec" src="/img/logos/convatec.png"></div>'
		link:
			href: 'http://convatec-russia.ru/'
			caption: 'convatec-russia.ru'
	'smith_nephew':
		text: '<div class="logo-wrapper"><img alt="Smith & Nephew GmbH" src="/img/logos/smith-nephew.png"></div>'
		link:
			href: 'http://www.smith-nephew.com/'
			caption: 'www.smith-nephew.com'
	'hartmann':
		text: '<div class="logo-wrapper"><img alt="PAUL HARTMANN" src="/img/logos/hartmann.png"></div>'
		link:
			href: 'http://www.combisensation.ru/'
			caption: 'www.combisensation.ru'
	'l_r':
		text: '<div class="logo-wrapper"><img alt="Lohmann & Rauscher GmbH" src="/img/logos/lohmann-rauscher.png"></div>'
		link:
			href: 'http://www.lohmann-rauscher.ru/'
			caption: 'www.lohmann-rauscher.ru'
	'medica':
		text: '<div class="logo-wrapper"><img alt="НПП «МЕДИКА»" src="/img/logos/medika.png"></div>'
		link:
			href: 'http://npwt.ru/'
			caption: 'www.npwt.ru'
	'primed':
		text: '<div class="logo-wrapper"><img alt="PRIMED" src="/img/logos/primed.png"></div>'
		link:
			href: 'http://www.primed.ca/'
			caption: 'www.primed.ca'
	'apexmed':
		text: '<div class="logo-wrapper"><img alt="Apexmed" src="/img/logos/apexmed.svg"></div>'
		link:
			href: 'http://www.apexmed.ru/'
			caption: 'www.apexmed.ru'


`window.catalog_source = [

	{
		"company": "convatec",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>ConvaTec Avelle&trade;</span><span class='unit-name__rus'>Конватек Авелле&trade;</span>",
		"img_src": "/img/avelle.jpg",
		"img_alt": "ConvaTec Avelle",
		"link": "/catalog/therapy_unit/avelle",
		"descr": "Насос для лечения ран",
		"items": [
		{
			"code": "421551",
			"amount": 1,
			"features": []
		},
		{
			"code": "",
			"amount": "",
			"features": []
		},
		{
			"code": "",
			"amount": "",
			"features": ["В комплекте с аппаратом продаются раневые покрытия с фиксирующими полосками:"]
		},
		{
			"code": "421552",
			"amount": 5,
			"features": ["16×16 см"]
		},
		{
			"code": "421553",
			"amount": 5,
			"features": ["16×21 см"]
		},
		{
			"code": "421554",
			"amount": 5,
			"features": ["12×21 см"]
		},
		{
			"code": "421555",
			"amount": 5,
			"features": ["12×31 см"]
		}
		]
	},

	{
		"company": "smith_nephew",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Renasys<sup>©</sup> EZ Plus</span><span class='unit-name__rus'>Ренасис И-ЗИ Плюс</span>",
		"img_src": "/img/renasys_ez_plus.jpg",
		"img_alt": "Renasys© EZ Plus",
		"link": "/catalog/therapy_unit/renasys_ez_plus",
		"descr": "",
		"items": [
		{
			"code": "66801243",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "smith_nephew",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Renasys<sup>©</sup> GO</span><span class='unit-name__rus'>Ренасис Гоу</span>",
		"img_src": "/img/renasys_go.jpg",
		"img_alt": "Renasys© Go",
		"link": "/catalog/therapy_unit/renasys_go",
		"descr": "",
		"items": [
		{
			"code": "66801496",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "smith_nephew",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Renasys<sup>©</sup> PICO</span><span class='unit-name__rus'>Ренасис Пико</span>",
		"img_src": "/img/renasys_pico.jpg",
		"img_alt": "Renasys© PICO",
		"link": "/catalog/therapy_unit/renasys_pico",
		"descr": "",
		"items": [
		{
			"code": "66801356",
			"amount": 1,
			"features": ["Multisite Large"]
		},
		{
			"code": "66801357",
			"amount": 1,
			"features": ["Multisite Large"]
		},
		{
			"code": "66801358",
			"amount": 1,
			"features": ["10×20 см"]
		},
		{
			"code": "66801359",
			"amount": 1,
			"features": ["10×30 см"]
		},
		{
			"code": "66801360",
			"amount": 1,
			"features": ["10×40 см"]
		},
		{
			"code": "66801361",
			"amount": 1,
			"features": ["15×15 см"]
		},
		{
			"code": "66801362",
			"amount": 1,
			"features": ["15×20 см"]
		},
		{
			"code": "66801363",
			"amount": 1,
			"features": ["15×30 см"]
		},
		{
			"code": "66801364",
			"amount": 1,
			"features": ["20×20 см"]
		},
		{
			"code": "66801365",
			"amount": 1,
			"features": ["25×25 см"]
		},
		{
			"code": "66800953",
			"amount": 1,
			"features": ["10×40 см"]
		},
		{
			"code": "66800954",
			"amount": 1,
			"features": ["15×15 см"]
		}
		]
	},

	{
		"company": "smith_nephew",
		"category": "canister",
		"name": "Renasys<sup>©</sup> EZ Plus Емкости для сбора экссудата<span class='unit-name__rus'>Канистра для Ренасис И-ЗИ Плюс</span>",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "66800913",
			"amount": 1,
			"features": ["250 мл."]
		},
		{
			"code": "66800912",
			"amount": 1,
			"features": ["800 мл."]
		}
		]
	},

	{
		"company": "smith_nephew",
		"category": "canister",
		"name": "Renasys<sup>©</sup> GO Емкости для сбора экссудата<span class='unit-name__rus'>Канистра для Ренасис Гоу</span>",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "66800914",
			"amount": 1,
			"features": ["300 мл."]
		}
		]
	},

	{
		"company": "smith_nephew",
		"category": "canister",
		"name": "Renasys<sup>©</sup> GO Емкости для сбора экссудата Large<span class='unit-name__rus'>Канистра для Ренасис Гоу</span>",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Совместима с Suprasorb CNP® P1 и аппаратом ВаСта.",
		"items": [
		{
			"code": "66800916",
			"amount": 1,
			"features": ["750 мл."]
		}
		]
	},

	{
		"company": "hartmann",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>VivanoTec<sup>®</sup> S 042 NPWT</span><span class='unit-name__rus'>Вивано Тэк С 042 НПВТ</span>",
		"img_src": "/img/hartmann_vivano.jpg",
		"img_alt": "VivanoTec® S 042 NPWT",
		"link": "/catalog/therapy_unit/hartmann_vivavo",
		"descr": "",
		"items": [
		{
			"code": "409 5020",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "hartmann",
		"category": "canister",
		"name": "VivanoTec<sup>®</sup> Емкости для сбора экссудата",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Совместим с VivanoTec<sup>®</sup> S 042 NPWT",
		"items": [
		{
			"code": "409 5213",
			"amount": 5,
			"features": ["800 мл."]
		},
		{
			"code": "409 5223",
			"amount": 10,
			"features": ["800 мл."]
		},
		{
			"code": "409 5243",
			"amount": 5,
			"features": ["300 мл."]
		},
		{
			"code": "409 5253",
			"amount": 10,
			"features": ["300 мл."]
		}
		]
	},

	{
		"company": "l_r",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Suprasorb CNP<sup>®</sup> P1</span><span class='unit-name__rus'>Супрасорб СиНП П1</span>",
		"img_src": "/img/suprasorb_p1.jpg",
		"img_alt": "Suprasorb CNP<sup>®</sup> P1",
		"link": "/catalog/therapy_unit/suprasorb_cnp_p1",
		"descr": "Стационарное устройство Suprasorb CNP® P1 для лечения ран отрицательным давлением в противоударном чемодане",
		"items": [
		{
			"code": "25291",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "l_r",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Suprasorb CNP<sup>®</sup> P2</span><span class='unit-name__rus'>Супрасорб СиНП П2</span>",
		"img_src": "/img/suprasorb_p2.jpg",
		"img_alt": "Suprasorb CNP<sup>®</sup> P2",
		"link": "/catalog/therapy_unit/suprasorb_cnp_p2",
		"descr": "Переносное устройство Suprasorb CNP® P2 для лечения ран отрицательным давлением с футляром для ношения в противоударном чемодане",
		"items": [
		{
			"code": "25751",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "l_r",
		"category": "canister",
		"name": "Сборник для экссудата, совместимый с Suprasorb CNP<sup>®</sup> P1 и аппаратом ВаСта.",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Многоразовый.",
		"items": [
		{
			"code": "39405",
			"amount": 1,
			"features": ["1000 мл."]
		}
		]
	},

	{
		"company": "l_r",
		"category": "canister",
		"name": "Пакет/вкладыш для сбора экссудата, совместимый с Suprasorb CNP<sup>®</sup> P1 и аппаратом ВаСта.",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Одноразовый. Помещается внутрь сборника для экссудата.",
		"items": [
		{
			"code": "39406",
			"amount": 1,
			"features": ["1000 мл."]
		}
		]
	},

	{
		"company": "l_r",
		"category": "canister",
		"name": "Сборник для экссудата, совместимый с Suprasorb CNP<sup>®</sup> P2",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "39785",
			"amount": 1,
			"features": ["250 мл."]
		}
		]
	},


	{
		"company": "medica",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Стабилизатор вакуума ВаСта</span>",
		"img_src": "/img/vasta.jpg",
		"img_alt": "Стабилизатор вакуума ВаСта",
		"link": "/catalog/therapy_unit/vasta",
		"descr": "Стабилизатор вакуума ВаСта для лечения инфицированных и гнойных ран",
		"items": [
		{
			"code": "(без артикула)",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "l_r",
		"category": "bandage",
		"name": "Стерильная прозрачная пленка для перевязки ран &laquo;Супрасорб F&raquo; (Suprаsorb F)",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Материалы перевязочные Супрасорб (Suprаsorb) для влажного заживления ран.",
		"items": [
		{
			"code": "20460",
			"amount": 10,
			"features": ["5×7см"]
		},
		{
			"code": "20461",
			"amount": 100,
			"features": ["5×7см"]
		},
		{
			"code": "20462",
			"amount": 10,
			"features": ["10×12см"]
		},
		{
			"code": "20463",
			"amount": 50,
			"features": ["10×12см"]
		},
		{
			"code": "20464",
			"amount": 10,
			"features": ["10×25см"]
		},
		{
			"code": "20465",
			"amount": 10,
			"features": ["15×20см"]
		},
		{
			"code": "20466",
			"amount": 10,
			"features": ["20×30см"]
		},
		{
			"code": "20467",
			"amount": 1,
			"features": ["10×100см"]
		}
		]
	},


	{
		"company": "primed",
		"category": "canister",
		"name": "Емкость накопительная многоразового применения Flovac",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Совместим с Suprasorb CNP® P1 и аппаратом ВаСта.",
		"items": [
		{
			"code": "31843",
			"amount": 40,
			"features": ["1000 мл."]
		}
		]
	},

	{
		"company": "primed",
		"category": "canister",
		"name": "Мешок дренажный с крышкой и фильтром, одноразовый Flovac",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "Совместим с Suprasorb CNP® P1 и аппаратом ВаСта.",
		"items": [
		{
			"code": "31848",
			"amount": 50,
			"features": ["1000 мл."]
		}
		]
	},

	{
		"company": "l_r",
		"category": "wound_filler",
		"name": "Губка для ран, стерильная",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "39401",
			"amount": 1,
			"features": ["10×15×1см"]
		},
		{
			"code": "39402",
			"amount": 1,
			"features": ["10×15×3см"]
		},
		{
			"code": "39403",
			"amount": 1,
			"features": ["25×15×1см"]
		},
		{
			"code": "39404",
			"amount": 1,
			"features": ["25×30×1см"]
		}
		]
	},

	{
		"company": "primed",
		"category": "wound_filler",
		"name": "Прокладка губчатая",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "24436",
			"amount": 10,
			"features": ["12×8×3см"]
		},
		{
			"code": "24432",
			"amount": 10,
			"features": ["12×16×3см"]
		},
		{
			"code": "24403",
			"amount": 10,
			"features": ["26×16×3см"]
		},
		{
			"code": "24407",
			"amount": 10,
			"features": ["240×31×3см"]
		}
		]
	},

	{
		"company": "primed",
		"category": "wound_filler",
		"name": "Прокладка губчатая тонкая",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "24435",
			"amount": 10,
			"features": ["12×8×1см"]
		},
		{
			"code": "24431",
			"amount": 10,
			"features": ["12×16×1см"]
		},
		{
			"code": "24401",
			"amount": 10,
			"features": ["26×16×1см"]
		},
		{
			"code": "24405",
			"amount": 10,
			"features": ["24×31×1см"]
		}
		]
	},

	{
		"company": "apexmed",
		"category": "canister",
		"name": "Канистра",
		"img_src": "",
		"img_alt": "",
		"link": "",
		"descr": "",
		"items": [
		{
			"code": "1302-02-002",
			"amount": 1,
			"features": ["800 мл."]
		},
		{
			"code": "1302-02-001",
			"amount": 1,
			"features": ["350 мл."]
		}
		]
	},

	{
		"company": "apexmed",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Sensitec SensiVac WT-100</span><span class='unit-name__rus'>Сенситек Сенсивак ВТ-100</span>",
		"img_src": "/img/sensivac_wt-100.jpg",
		"img_alt": "Sensitec SensiVac WT-100",
		"link": "/catalog/therapy_unit/sensivac_wt-100",
		"descr": "Аспиратор для вакуумной терапии ран Sensitec SensiVac WT-100",
		"items": [
		{
			"code": "1302-02-100",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "apexmed",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Sensitec SensiVac WT-110</span><span class='unit-name__rus'>Сенситек Сенсивак ВТ-110</span>",
		"img_src": "/img/sensivac_wt-110.jpg",
		"img_alt": "Sensitec SensiVac WT-110",
		"link": "/catalog/therapy_unit/sensivac_wt-110",
		"descr": "Аспиратор для вакуумной терапии ран Sensitec SensiVac WT-110",
		"items": [
		{
			"code": "1302-02-110",
			"amount": 1,
			"features": []
		}
		]
	},

	{
		"company": "apexmed",
		"category": "therapy_unit",
		"name": "<span class='unit-name-main'>Sensitec SensiVac WT-200</span><span class='unit-name__rus'>Сенситек Сенсивак ВТ-200</span>",
		"img_src": "/img/sensivac_wt-200.png",
		"img_alt": "Sensitec SensiVac WT-200",
		"link": "/catalog/therapy_unit/sensivac_wt-200",
		"descr": "Аспиратор для вакуумной терапии ран Sensitec SensiVac WT-200",
		"items": [
		{
			"code": "1302-02-200",
			"amount": 1,
			"features": []
		}
		]
	},

]`

MainApp = Backbone.View.extend {
	events:
		'click .news-item__read-more': 'toggleNewsSection'
		'click .scroll-to-method': 'scrollToMethod'
		'click .more-info-link': 'moreInfo'
		'click .more-news-link': 'moreNews'
		'click .webinar-info-link': 'webinarInfo'
		'click .common-block__video-link': 'revealVideo'
		'hide.bs.modal .modal': 'onModalHidden'

	initialize: () ->
		_.bind @scrollToMethod, @
		_.bind @toggleNewsSection, @
		_.bind @moreInfo, @
		_.bind @moreNews, @
		_.bind @webinarInfo, @
		_.bind @revealVideo, @
		_.bind @resizeHandler, @
		_.bind @onModalHidden, @

		@window = $ window
		do @render

	render: () ->
		@newsItemWrapper = $ '.news-item-wrapper'
		@fullWrapper = $ '.news-item-wrapper__full'
		@fullContainer = $ '.news-item-wrapper__container'
		@moreInfoModal = $ '#more-modal__info'
		@moreNewsModal = $ '#more-modal__news'
		@webinarInfoModal = $ '#more-modal__webinar'

		@articleNavigation = $ '.article-navigation'

		@methodLink = $ '.scroll-to-method'
		@methodStart = @articleNavigation.offset().top
		@methodStart = @newsItemWrapper.offset().top if @newsItemWrapper.length > 0
		@methodStart = @methodStart - 30;


		# load Youtube API
		tag = document.createElement 'script'
		tag.src = "https://www.youtube.com/iframe_api"
		firstScriptTag = document.getElementsByTagName('script')[0]
		firstScriptTag.parentNode.insertBefore tag, firstScriptTag

		do @loadingPlayers

		@window.on 'resize', _.bind @resizeHandler, @

		return null

	loadingPlayers: () ->
		_self = @

		window.__processPlayer = (ev) ->
			_self[ev.target.a.id] = ev.target

		window.onYouTubeIframeAPIReady = () ->
			interview1 = new YT.Player('yt-interview-gorunov', {
				events: {
					'onReady': window.__processPlayer
				}
			})
			interview2 = new YT.Player('yt-interview-rodoman', {
				events: {
					'onReady': window.__processPlayer
				}
			})

			interview3 = new YT.Player('yt-festering-wound', {
				events: {
					'onReady': window.__processPlayer
				}
			})

			interview3 = new YT.Player('yt-interview-kalash', {
				events: {
					'onReady': window.__processPlayer
				}
			})

	toggleNewsSection: (ev) ->
		ev.preventDefault()
		return if not @newsItemWrapper
		@newsItemWrapper.toggleClass 'show-news'
		h = @fullContainer.height();
		if @fullWrapper.height() == 0
			@fullWrapper.css 'height', h + 'px'
		else
			@fullWrapper.css 'height', '0px'

	scrollToMethod: (ev) ->
		ev.preventDefault()
		$('body,html').animate({scrollTop: @methodStart + 'px'}, 300, 'swing')

	moreInfo: (ev) ->
		do ev.preventDefault
		do @moreInfoModal.modal

	moreNews: (ev) ->
		do ev.preventDefault
		do @moreNewsModal.modal

	webinarInfo: (ev) ->
		do ev.preventDefault
		do @webinarInfoModal.modal

	revealVideo: (ev) ->
		do ev.preventDefault
		modalId = $(ev.target).closest('a').attr 'data-modal'

		$modal = $ '#'+modalId

		return if $modal.length != 1

		@currentModal = $modal
		@currentPlayer = 'yt-'+modalId
		@_recalcModal $modal

		do @[@currentPlayer].playVideo
		do $modal.modal

	_recalcModal: ($modal) ->
		return if not $modal
		h = @window.height()
		w = @window.width()

		$dialog = $modal.find '.modal-dialog'

		console.log w, h, $dialog, w*0.8*0.5625 > h*0.9

		if w*0.8*0.5625 > h*0.9
			$dialog.attr 'style', 'width:'+(h*0.9*16/9)+'px'
		else
			$dialog.attr 'style', ''

	onModalHidden: (ev) ->
		@currentModal = null

		do @[@currentPlayer].pauseVideo if @currentPlayer

		@currentPlayer = null

	resizeHandler: (ev) ->
		console.log @currentModal
		@_recalcModal @currentModal
}

# Basic view switcher

window._qs = ( (str)->
	_strSections = str.split '/'
	strSections = []
	_.each _strSections, (item) ->
		if item != ''
			strSections.push item

	return strSections

)(window.location.pathname)

window.getCatalogCategory = () ->
	location = window.location.pathname
	if location.indexOf '/catalog' == -1
		return null

	result = location.replace '/catalog', ''
	result = result.replace '/', ''
	return result

fragment = document.location.pathname

$ () ->
	if fragment == '/'
		window.app = new MainApp({el: '.container-wrapper'})
	else if window._qs[0] == 'catalog' and not window._qs[2]
		window.app = new Catalog({el: '.catalog-page-wrapper'})

	callbackModal = $ '#callback-modal'
	focusField = $ '#callback-modal .name'
	form = $ '#callback-modal .phone-form'

	$('a[data-fire="callback"]').on 'click', (ev) ->
		callbackModal.modal()

	form.on 'submit', (ev) ->
		do ev.preventDefault
		formData = form.serializeArray()
		formJSON = {}
		for field in formData
			formJSON[field["name"]] = field["value"]

		$.ajax {
			type: "POST"
			url: '/send_mail'
			data: formJSON
		}

		callbackModal.modal 'hide'

